import { type } from "arktype";

// R-ADP-02: managed vocabulary, not free text.
export const adaptations = [
  "strength", "power", "hypertrophy", "capacity", "tissue_tolerance",
  "mobility", "motor_skill", "confidence", "rehabilitation", "aerobic_capacity", "impact_tolerance",
] as const;
export const Adaptation = type.enumerated(...adaptations);
export type Adaptation = typeof Adaptation.infer;

export const adaptationLabels: Record<Adaptation, string> = {
  strength: "Strength", power: "Power", hypertrophy: "Hypertrophy", capacity: "Work capacity",
  tissue_tolerance: "Tissue tolerance", mobility: "Mobility", motor_skill: "Motor skill",
  confidence: "Confidence", rehabilitation: "Rehabilitation", aerobic_capacity: "Aerobic capacity",
  impact_tolerance: "Impact tolerance",
};

export const movementPatterns = [
  "squat", "hinge", "lunge", "push_horizontal", "push_vertical", "pull_horizontal", "pull_vertical",
  "carry", "rotation", "anti_rotation", "locomotion", "jump", "swing", "isolation", "other",
] as const;
export const MovementPattern = type.enumerated(...movementPatterns);
export type MovementPattern = typeof MovementPattern.infer;

export const modalities = ["barbell", "dumbbell", "kettlebell", "bodyweight", "machine", "band", "cable", "bike", "run", "row", "ski", "sled", "other"] as const;
export const Modality = type.enumerated(...modalities);
export type Modality = typeof Modality.infer;

export const blockKinds = ["prep", "main", "accessory", "conditioning", "skill", "cooldown"] as const;
export const BlockKind = type.enumerated(...blockKinds);
export type BlockKind = typeof BlockKind.infer;

export const workKinds = ["working", "warmup", "teaching", "exploratory", "confidence", "test"] as const;
export const WorkKind = type.enumerated(...workKinds);
export type WorkKind = typeof WorkKind.infer;

// R-REV-03 fixed deviation reasons plus free text
export const deviationReasons = ["fatigue", "pain", "readiness", "time", "preference", "felt_strong", "coachs_call", "equipment", "other", "unknown"] as const;
export const DeviationReason = type.enumerated(...deviationReasons);
export type DeviationReason = typeof DeviationReason.infer;

export const dismissReasons = ["already_planned", "not_appropriate", "dont_believe", "later", "other"] as const;
export const DismissReason = type.enumerated(...dismissReasons);
export type DismissReason = typeof DismissReason.infer;

export const goalTypes = ["outcome", "performance", "health", "behavior"] as const;
export const GoalType = type.enumerated(...goalTypes);
export type GoalType = typeof GoalType.infer;

export const horizons = ["short", "long"] as const;
export const Horizon = type.enumerated(...horizons);
export type Horizon = typeof Horizon.infer;

export const channelKinds = ["email", "sms", "whatsapp", "telegram", "instagram", "messenger", "discord"] as const;
export const ChannelKind = type.enumerated(...channelKinds);
export type ChannelKind = typeof ChannelKind.infer;
/** Phase 0 adapters (BUILD_PLAN §1.2 ADR-008). */
export const phase0Channels: readonly ChannelKind[] = ["email", "sms"];

export const roles = ["super_admin", "trainer", "trainee"] as const;
export const Role = type.enumerated(...roles);
export type Role = typeof Role.infer;

export const tiers = ["free_period", "tier_1", "tier_2_5", "tier_6_10", "tier_11_25", "tier_26_plus"] as const;
export const Tier = type.enumerated(...tiers);
export type Tier = typeof Tier.infer;

export const units = ["lb", "kg"] as const;
export const Unit = type.enumerated(...units);
export type Unit = typeof Unit.infer;
